export enum WayfindingType {
    cta = 'cta',
    download = 'download',
    enter = 'enter',
    left = 'left',
    right = 'right',
    up = 'up',
}
